var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header__menu"},[_c('div',{staticClass:"header__menu--left"},[_c('img',{attrs:{"src":"/static/img/common/header/back.svg"},on:{"click":_vm.back}}),_vm._v(" "),_c('span',{staticClass:"header__menu__pageName"},[_vm._v(_vm._s(_vm.displayPageName))])]),_vm._v(" "),_c('div',{staticClass:"header__menu--right"})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39582c97","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/common/BackHeader.vue
// module id = null
// module chunks = 